
import { Injectable } from "@angular/core";
import { Cents, Seconds } from "../model/music";
/**
 * Provides access to the Web Audio API.
 */
@Injectable()
export class WebAudioService {

	//the main Web Audio API context
	private context: AudioContext
	//the loaded sounds. key is sound name
	private sounds: Map<string, AudioBuffer> = new Map()
	//the currently played sources
	private playedSources: AudioBufferSourceNode[] = []

	constructor() {
		let AudioContext = window["AudioContext"] /* older webkit browsers: */ || window["webkitAudioContext"]
		if (AudioContext)
			this.context = new AudioContext()
	}

	/**
	 * Returns true, if sound is available on this system.
	 */
	isAvailable() : boolean {
		return this.context != null
	}

	/**
	 * Loads the audio file with the given sound name.
	 */
	loadSoundFile(soundName: string): Promise<void> {
		return new Promise<void>((resolve, reject) => {
			//already loaded?
			if (this.sounds.has(soundName))
				resolve()
			else {
				console.log(`Loading sound ${soundName} ...`)
				let request = new XMLHttpRequest();
				request.open('GET', `assets/samples/${soundName}.mp3`, true)
				request.responseType = 'arraybuffer'
				request.onload = () => {
					this.context.decodeAudioData(request.response, (buffer) => {
						console.log(`Sound ${soundName} loaded`)
						this.sounds.set(soundName, buffer)
						resolve()
					}, reject)
				}
				request.onerror = err => reject(err)
				request.send()
			}
		})
	}

	/**
	 * Plays the given sound starting at the given time delay and tuned by the given amount of cents.
	 */
	play(soundFileName: string, time: Seconds = 0, volume = 1, correction: Cents = 0) {
		let source: AudioBufferSourceNode = this.context.createBufferSource()
		let baseBuffer = this.sounds.get(soundFileName)
		if (correction == 0) {
			source.buffer = baseBuffer
		}
		else {
			let hz = baseBuffer.sampleRate * Math.pow(2, (correction/1200)) //cents to hz
			let pitchedBuffer = this.context.createBuffer(1, baseBuffer.length, hz)
			pitchedBuffer.copyToChannel(baseBuffer.getChannelData(0), 0)
			source.buffer = pitchedBuffer
		}
		//volume
		let gain = this.context.createGain()
		source.connect(gain)
		gain.gain.value = volume
		gain.connect(this.context.destination)
		//play sound
		source.start(this.context.currentTime + time)
		//remember it as a currently playing sound
		this.playedSources.push(source)
	}

	/**
	 * Immediately stops all playing sounds.
	 */
	stopAll() {
		for (let source of this.playedSources)
			source.stop()
		this.playedSources = []
	}

}


// WEBPACK FOOTER //
// ./src/service/webaudio.service.ts